<template>
  <v-layout row wrap>
    <v-flex xs12>
      <div class="v-input v-text-field theme--light">
        <div class="v-input__control">
          <div class="v-input__slot">
            <div class="v-text-field__slot">
              <label
                aria-hidden="true"
                class="v-label v-label--active theme--light"
                style="left: 0; right: auto; position: absolute;"
              >{{ label }}</label>
              <el-autocomplete
                v-model="address"
                :fetch-suggestions="AutocompleteSearch"
                :required="required"
                @select="AutocompleteSelect"
                :placeholder="placeholder"
                :trigger-on-focus="false"
                :id="`form-address-${input.name}`"
              ></el-autocomplete>
            </div>
          </div>
          <div class="v-text-field__details">
            <div class="v-messages theme--light">
              <div class="v-messages__wrapper"></div>
            </div>
          </div>
        </div>
      </div>
    </v-flex>
    <v-flex xs12>
      <v-flex xs12 mb-3 v-if="address_data" id="address-suggestion">
        <div class="adress-table">
          <div class="at-wrap">
            <div class="atw-title">Почтовый индекс</div>
            <div class="atw-data">{{address_data.postal_code}}</div>
          </div>
          <div class="at-wrap">
            <div class="atw-title">Код региона</div>
            <div class="atw-data">{{address_data.region_kladr_id}}</div>
          </div>
          <div class="at-wrap">
            <div class="atw-title">Регион</div>
            <div class="atw-data">{{address_data.region_with_type}}</div>
          </div>
          <div class="at-wrap">
            <div class="atw-title">Город</div>
            <div class="atw-data">{{address_data.city_with_type}}</div>
          </div>
          <div class="at-wrap">
            <div class="atw-title">Улица</div>
            <div class="atw-data">{{address_data.street_with_type}}</div>
          </div>
          <div class="at-wrap">
            <div class="atw-title">Номер дома</div>
            <div class="atw-data">{{address_data.house}}</div>
          </div>
          <div class="at-wrap">
            <div class="atw-title">Корпус</div>
            <div class="atw-data">{{address_data.block}}</div>
          </div>
          <div class="at-wrap">
            <div class="atw-title">Номер квартиры</div>
            <div class="atw-data">{{address_data.flat}}</div>
          </div>
        </div>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios';

export default {
  props: [
    'label',
    'placeholder',
    'input',
    'required',
  ],
  data() {
    return {
      address: '',
      address_data: null,
      suggestions: [],
      suggestions_items: [],
    };
  },
  methods: {
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch(err => console.warn(err));
    },
    AutocompleteSelect(item) {
      const app = this;
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.address_data = sug.data;
          document.getElementById(`form-address-${this.$props.input.name}`).focus();
          this.$emit('select', {
            address: sug.value,
            data: sug.data,
            inputName: app.$props.input.name,
          });
        }
      });
    },

  },
};
</script>

<style scoped>

</style>
